import { render } from "./Details.vue?vue&type=template&id=3a661eaa&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=3a661eaa&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\game-forecast\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a661eaa"]])

export default __exports__